const e = (n) => async (r) => await n(r).owner();
export {
  e as commonOwner
};
//# sourceMappingURL=common.mjs.map
